import React from 'react'

import { Card } from 'primereact/card'

import FieldInputTextarea from '../common/FieldInputTextarea'

const RedactedDetails = ({ showAsTextOnly, validationRules }) => {
  return (
    <Card title="Notes (Admin only)">
      <div className="p-grid">
        <div className="p-col-12 p-md-12 p-lg-12">
          <FieldInputTextarea rows={3} field={"RedactedDetails"} label={"Enter redacted details or reason for cancellation/rejection (public will not see this field)"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
      </div>
    </Card>
  )
}

export default RedactedDetails


// WEBPACK FOOTER //
// ./src/components/common/RedactedDetails.js